import { jsx as _jsx } from "react/jsx-runtime";
import { BASE_CONF } from "./config.js";
const Row = ({ around, as: Component = 'div', between, bottom, center, children, className = '', end, first, last, middle, reverse = false, start, style: customStyle = {}, top, }) => {
    const style = {
        boxSizing: 'border-box',
        display: 'flex',
        flex: '0 1 auto',
        flexDirection: reverse ? 'row-reverse' : 'row',
        flexWrap: 'wrap',
        marginRight: `${(BASE_CONF.gutterWidth / 2) * -1}rem`,
        marginLeft: `${(BASE_CONF.gutterWidth / 2) * -1}rem`,
    };
    // Apply alignment based on props
    if (start)
        style.justifyContent = 'flex-start';
    if (center)
        style.justifyContent = 'center';
    if (end)
        style.justifyContent = 'flex-end';
    if (around)
        style.justifyContent = 'space-around';
    if (between)
        style.justifyContent = 'space-between';
    if (top)
        style.alignItems = 'flex-start';
    if (middle)
        style.alignItems = 'center';
    if (bottom)
        style.alignItems = 'flex-end';
    if (first)
        style.order = -1;
    if (last)
        style.order = 1;
    return (_jsx(Component, { className: className, style: { ...style, ...customStyle }, children: children }));
};
Row.displayName = 'Row';
export default Row;
//# sourceMappingURL=row.js.map